module.exports = __webpack_public_path__ + "340440c47f0190ee4f3b3516eb71f6f3.png";